import { logger } from '@/lib/logger';
import { fetchCommunityAutologinUrl } from '@/services/communityAutologin.service';
import { Linking } from 'react-native';

/**
 * Open a WordPress page in the device's default browser, logged in: mints the
 * same one-time autologin URL the Hang WebView uses (wp-autologin edge fn →
 * bridge token) and hands it to the browser, which lands on `next` with WP
 * session cookies set. The token is single-use and short-lived, so it is safe
 * sitting in browser history.
 *
 * Falls back to opening the plain URL (logged out — today's behavior) when the
 * login URL can't be minted (network error, or the user isn't a member).
 */
export async function openWpUrlInBrowserLoggedIn(url: string, next: string): Promise<void> {
  try {
    const result = await fetchCommunityAutologinUrl(next);
    if (result.status === 'ok') {
      await Linking.openURL(result.loginUrl);
      return;
    }
    logger.warn('[wpBrowserAutologin] Falling back to plain URL:', result.status);
  } catch (error) {
    logger.warn('[wpBrowserAutologin] Error, falling back to plain URL:', error);
  }
  Linking.openURL(url).catch(() => {});
}
